<script setup lang="ts">
import { Link } from "@inertiajs/vue3";
import { route } from "ziggy-js";
import { computed, ref, watch, nextTick, onMounted } from "vue";
import mermaid from "mermaid";

let props = defineProps({
    markdown: String,
})

let root = ref();

function initMermaid() {
    mermaid.initialize({
        startOnLoad: false,
    });
}
let showdownKey = ref(0);

async function renderMermaid() {
    await nextTick();
    if(!root.value) return;
    await mermaid.run({
        nodes: root.value.querySelectorAll(".mermaid"),
    })

    await nextTick();
    if(root.value.querySelectorAll(".mermaid").length !== 0){
        clearInterval(interval.value);
        interval.value = null;
    }
}

let interval = ref(null);
onMounted(()=>{
    initMermaid();
    renderMermaid();
    interval.value = setInterval(()=>{
    renderMermaid();
}, 1000);
})


let computedMarkdown = computed(()=>{
    let markdown = props.markdown ?? "";
    // Resolve route() calls in markdown. Quote-safe: supports route('name') / route("name", {...}).
    markdown = markdown.replace(/\broute\(([^)]*)\)/g, (match, args) => {
        try {
            return new Function("route", `return route("${args}")`)(route);
        } catch {
            return match;
        }
    });
    // If route() was inside a Vue binding (:href="route(...)"), the replace yields
    // :href="/path" which is invalid JS — demote to a static attribute.
    markdown = markdown.replace(/:([\w-]+)="(\/[^"]*)"/g, '$1="$2"');
    return markdown;
})

let vueTemplateComponents = {
    Link,
}

let markdownTemplate = ref();


let tables = computed(()=>{
    if(typeof window !== "undefined") {
        let tables = markdownTemplate.value?.$el?.getElementsByTagName?.("table");
        if(tables){
            return tables
        }
    }
    return [];
})

watch(tables, (newVal)=>{
    for(let table of newVal){
        let ths = table.getElementsByTagName("th");
        // get text of each th and add it as a data-label attribute onto the cells of the table
        for(let i = 0; i < ths.length; i++){
            let th = ths[i];
            let dataLabel = th.innerText;
            let tds = table.getElementsByTagName("td");
            for(let td of tds){
                if(td.cellIndex === i){
                    td.setAttribute("data-label", dataLabel);
                }
            }
        }
    }
}, {deep: true})
</script>
<template>
    <div class="showdown-container" ref="root">
        <VueShowdown
            :extensions="['mermaid']"
            :key="showdownKey"
            ref="markdownTemplate"
            :markdown="computedMarkdown"
            vue-template
            :vue-template-components="vueTemplateComponents"
        />
    </div>
</template>
<style lang="scss" >
    .showdown-container {
        pre:has(.mermaid) {
            background-color: transparent !important;
            border: none !important;
            padding: 0 !important;
        }

        & img {
            margin: auto !important;
            width: 100% !important;
        }
    }

</style>
